import { Component, Injector, OnInit, ViewChild, ElementRef } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ProgressService } from 'src/app/service/ProgressService';
import { UserService } from 'src/app/service/UserService';
import { User } from 'src/app/model/user';
import { environment } from 'src/environments/environment';
import { BaseComponent } from '../common/BaseComponent';
import { BpsEmailValidator } from 'src/app/validator/BpsEmailValidator';
import { PasswordValidator } from 'src/app/validator/PasswordValidator';
import { CommonService } from 'src/app/service/CommonService';

@Component({
  selector: 'app-password-forgot',
  templateUrl: './password-forgot.component.html',
})
export class PasswordForgotComponent extends BaseComponent implements OnInit {
  @ViewChild('progressDialog') progressDialogElementRef!: ElementRef<HTMLDialogElement>;
  passwordForgotForm: FormGroup;
  submitted = false;
  canceled = false;
  restSub: Subscription;
  appErrorPrefix: string = 'bss.api.error';
  errorCode: string;
  respErrorCode: string;

  constructor(
    injector: Injector,
    public progressService: ProgressService,
    public rest: UserService,
    public commonService: CommonService) {
    super(injector);
    this.submitted = false;
  }

  checkPkiUser() {
    let loginEmail = sessionStorage.getItem("loginEmail");
    console.log("sessionStorage.loginEmail: " + loginEmail);

    if (loginEmail) {
      this.commonService.checkPkiUser(loginEmail, (result) => {
        if (result) {
          console.log("checkPki found true");
          this.router.navigate(['public/requestError'], { queryParams: {error_code:16}});
        }
      });
    }
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      console.log("forgot-pass-params" + params);
      this.errorCode = (params['error'])?.trim() ?? '';
      if (this.errorCode.length > 0) {
        this.checkPkiUser();
        this.appError = true;
      }
    });

    this.passwordForgotForm = new FormGroup({
      email: new FormControl(
        null,
        Validators.compose([Validators.required, PasswordValidator.invalidEmail, BpsEmailValidator.restricted])
      ),
    });
  }
  ngAfterViewInit() {

    this.progressService.setDialog(this.progressDialogElementRef.nativeElement);

  }

  getErrorMessage(): string {
    if (this.errorCode === "account_locked") {
      this.appError = true;
      this.appErrorMessage = this.appErrorPrefix + ".901";
    } else if (this.errorCode === "password_expired") {
      this.appError = true;
      this.appErrorMessage = this.appErrorPrefix + ".902";
    } else if (this.errorCode === "reset_password") {
      this.appError = true;
      this.appErrorMessage = this.appErrorPrefix + ".903";
    }

    if (this.appError) {
      return this.appErrorMessage;
    }
    this.appError = true;
    return this.appErrorMessage;

  }

  onSubmit() {
    this.submitted = true;
    if (this.passwordForgotForm.invalid) {
      return;
    }
    this.callForgotPasswordApi();
  }

  onCancel() {
    this.canceled = true;
    this.checkRedirectUrl();
  }

  callForgotPasswordApi() {
    let user = new User();
    this.errorCode = null;
    user.email = this.passwordForgotForm.get('email').value;
    this.progressService.open();
    this.restSub = this.rest.forgotPassword(user).subscribe((response) => {
      console.log('get-data:' + JSON.stringify(response));
      if (response.result == 1) {
        this.appError = true;
        this.respErrorCode = response.error_code;
        this.errorCode = response.error_code;
        //this.appErrorMessage = this.getMessage(this.appErrorPrefix + "." + response.error_code);
        this.appErrorMessage = this.appErrorPrefix + "." + this.errorCode;
      } else {
        this.appError = false;
        sessionStorage.setItem("pwdResetUser", JSON.stringify(user));
        this.router.navigate(['public/password/reset']);
      }
    }, (error) => { this.processError(error) },

      () => {

        this.progressService.close();

      });
  }

  ngOnDestroy() {
    if (this.restSub) {
      this.restSub.unsubscribe();
    }
  }

}
